import fetch from '../utils/fetch';

export const getOrganizations = brandName => fetch(`/core/api/organizations?brandName=${brandName}`);

export const getVoSchools = () => fetch('/core/api/organizations/vo');
